import React, { useState } from 'react';
import { Modal, Col, Row, Popconfirm, Table, Space } from 'antd';
import AddUserAgentWage from "./AddUserAgentWage";
import EditUserAgentWage from "./EditUserAgentWage";
import strings from "../../utils/strings";
import UserServices from '../../services/UserServices';
import { usePersistedStore } from '../../store/persisted-store';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';

export default function UserWageSetting({ userId }) {
    const general = useGeneralStore();
    const { getBranchNames, business, users, GET_USER_AGENT_WAGE } = usePersistedStore()

    const [selectedUserAgentWage, setSelectedUserAgentWage] = useState(null);
    const visible = general.view.userWageSettingModal;
    const userAgentWage = users.userAgentWage;
    const currentBusiness = business.currentBusiness;
    const { token } = currentBusiness;

    function deleteUserAgentWage(UserId, BranchId) {
        UserServices.deleteUserAgentWage(UserId, BranchId, token).then((res) => {

            general.NotifSuccess('رشته با موفقیت حذف شد.')
            getUserAgentWage(UserId);
        }).catch((error) => {

        })
    }

    function getUserAgentWage(recordId) {
        UserServices.getUserAgentWage(recordId, token).then((res) => {
            GET_USER_AGENT_WAGE(res.data)
        }).catch((error) => {

        })
    }

    const columns = [
        {
            title: "رشته بیمه",
            dataIndex: "BranchName",
            key: "BranchName",
            ellipsis: true,
            render: (text) => <span style={{ color: "#5ec393" }}>{text}</span>
        },
        {
            title: "درصد کارمزد",
            dataIndex: "WagePercent",
            key: "WagePercent",
            render: (text) => text && <span style={{ color: "#f00000" }}>{strings.getFarsiNum(text)} %</span>
        },
        {
            title: "مبلغ کارمزد",
            dataIndex: "WagePrice",
            key: "WagePrice",
            render: (text) => text && <span style={{ color: "#f00000" }}>{strings.currencyFormat(text)} ريال</span>
        },
        {
            title: "",
            dataIndex: "operation",
            key: "operation",
            ellipsis: true,
            render: (_, record) =>
                userAgentWage.length > 0 && (
                    <Space size="middle">
                        <button type="dashed" className="btn btn-warning btn-sm waves-effect waves-light"
                            onClick={() => {
                                general.ToggleUserEditAgentWage();
                                setSelectedUserAgentWage(record);
                            }}>
                            <i className="far fa-edit font-size-16 align-middle mr-2"></i> ویرایش
                        </button>
                        <Popconfirm
                            title="آیا از حذف رشته مطمئن هستید؟"
                            onConfirm={() => deleteUserAgentWage(record.UserId, record.BranchId)}
                        >
                            <button type="danger" className="btn btn-danger btn-sm waves-effect waves-light">
                                <i className="fas fa-minus font-size-16 align-middle mr-2"></i> حذف
                            </button>
                        </Popconfirm>
                    </Space>
                ),
        },
    ];

    return (
        <Modal
            width={1000}
            title="تنظیم کارمزد کاربر"
            className="custom-table"
            visible={visible}
            footer={false}
            onCancel={() => general.ToggleUserWageSettingModal()}>
            <Row gutter={24} justify="end">
                <button type="primary" className="btn btn-primary btn-sm waves-effect waves-light mb-10 float-left"
                    style={{ marginLeft: "12px" }}
                    onClick={() => {
                        general.ToggleUserAddAgentWage();
                        getBranchNames();
                    }}>
                    <i className="fas fa-plus font-size-16 align-middle mr-2"></i>افزودن رشته
                </button>
                <Col span={24}>
                    {userAgentWage &&
                        <Table
                            style={{ overflowX: 'scroll', display: "contents", paddingTop: "50px" }}
                            bordered
                            columns={columns}
                            scroll={true}
                            rowKey="BranchId"
                            dataSource={userAgentWage}
                        />
                    }
                    <AddUserAgentWage userId={userId} />
                    {selectedUserAgentWage && <EditUserAgentWage userAgentWage={selectedUserAgentWage} />}
                </Col>
            </Row>
        </Modal >
    )
}

